<template>
  <div>
    <slot name="signBlockList"></slot>
    <canvas v-for="page in numPages"
            :ref="`the-canvas${page}`"
            :key="page"></canvas>
  </div>

</template>
<script>
// import pdfjsLib from 'pdfjs-dist/webpack'
import { getCookie } from '@/utils'
import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

export default {
  name: 'pdf-viewer',

  props: {
    src: String,
    base64Data: String,
    cfgRatio: {
      type: String,
      default: '1'
    },
    usedMaskLoading: { // 旗標設，是否於讀取PDF 過程中提供等候畫面遮罩
      type: Boolean,
      default: false
    },
    stretch: { // 是否要延展100%
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      pdfDoc: null,
      pageNum: 1,
      pageRendering: false,
      pageNumPending: null,
      scale: 1,
      numPages: 0,
      baseUrl: this.$api.defaults.baseURL
    }
  },

  watch: {
    src: {
      handler (src) {
        /*
        if (src && !this.$isHttp(src)) {
          src = window.location.origin + src
        }
        */
        if (src) {
          src = this.baseUrl + '/' + src
          src && this.fetchPDF(src)
        }
      },
      immediate: true
    },
    base64Data: {
      handler (v) {
        v && this.fetchPDFb64(v)
      },
      immediate: true
    }
  },

  methods: {
    startLoading () {
      this.$store.commit('START')
    },
    endLoading () {
      this.$store.commit('END')
    },
    fetchPDF (src) {
      const vm = this
      let tasks = []
      let xsrft = getCookie('!Proxy!RestApiProxyXSRF-TOKEN')
      if (!xsrft) {
        xsrft = getCookie('XSRF-TOKEN')
      }
      let loadingTask = pdfjsLib.getDocument({
        url: src,
        httpHeaders: { 'X-XSRF-TOKEN': xsrft },
        withCredentials: true // 允許攜帶cookie
      })
      if (vm.usedMaskLoading) { // 透過旗標決定是否要有等候遮罩畫面
        vm.startLoading()
      }
      loadingTask.promise.then(function (pdfDoc) {
        // 處理之前遺留的物件，避免記憶體洩漏問題
        let oldPdfDoc = vm.pdfDoc
        if (oldPdfDoc && oldPdfDoc.cleanup) {
          oldPdfDoc.cleanup()
          oldPdfDoc.destroy()
        }
        vm.pdfDoc = pdfDoc
        vm.numPages = pdfDoc.numPages
        vm.$nextTick(() => {
          for (let index = 1; index <= pdfDoc.numPages; index++) {
            tasks.push(vm.renderPage(index))
          }
          Promise.all(tasks).then(() => {
            if (vm.usedMaskLoading) {
              vm.endLoading()
            }
          // console.log(`rendesr success : [${src}]`)
          })
        })
      }).catch(() => {
        console.log('pdfjsLib error')
        if (vm.usedMaskLoading) {
          vm.endLoading()
        }
        vm.$alert('文件產出發生異常，請聯絡系統管理員。', () => {
          window.location.reload()
        })
      })
    },
    fetchPDFb64 (base64) {
      let decodedBase64 = atob(base64)
      const vm = this
      let tasks = []
      let xsrft = getCookie('!Proxy!RestApiProxyXSRF-TOKEN')
      if (!xsrft) {
        xsrft = getCookie('XSRF-TOKEN')
      }
      let loadingTask = pdfjsLib.getDocument({
        data: decodedBase64,
        httpHeaders: { 'X-XSRF-TOKEN': xsrft },
        withCredentials: true // 允許攜帶cookie
      })
      loadingTask.promise.then(function (pdfDoc) {
        // 處理之前遺留的物件，避免記憶體洩漏問題
        let oldPdfDoc = vm.pdfDoc
        if (oldPdfDoc && oldPdfDoc.cleanup) {
          oldPdfDoc.cleanup()
          oldPdfDoc.destroy()
        }
        vm.pdfDoc = pdfDoc
        vm.numPages = pdfDoc.numPages
        vm.$nextTick(() => {
          for (let index = 1; index <= pdfDoc.numPages; index++) {
            tasks.push(vm.renderPage(index))
          }
          Promise.all(tasks).then(() => {
          // console.log(`rendesr success : [${src}]`)
          })
        })
      })
    },
    renderPage (num) {
      this.pageRendering = true
      let vm = this
      const CSS_UNITS = 96.0 / 72.0 // --螢幕解析與列印解析的轉換比率
      this.pdfDoc.getPage(num).then(function (pdfPage) {
        const [canvas] = vm.$refs[`the-canvas${num}`]
        if (!canvas) return
        const canvasContext = canvas.getContext('2d')

        const dpr = window.devicePixelRatio || 1
        const bsr =
          canvasContext.webkitBackingStorePixelRatio ||
          canvasContext.mozBackingStorePixelRatio ||
          canvasContext.msBackingStorePixelRatio ||
          canvasContext.oBackingStorePixelRatio ||
          canvasContext.backingStorePixelRatio ||
          1
        let ratio = dpr / bsr
        if (vm.cfgRatio) { // 客製化比例定義
          ratio = parseFloat(vm.cfgRatio)
        }
        ratio = ratio * CSS_UNITS
        // const w = vm.$refs.frame.clientWidth
        const viewport = pdfPage.getViewport({ scale: ratio })
        const { width, height } = viewport
        canvas.width = width
        canvas.height = height
        if (!vm.stretch) {
          canvas.style.width = `${width}px`
          canvas.style.height = `${height}px`
        } else {
          canvas.style.width = '100%'
          canvas.style.height = '100%'
        }
        // canvasContext.setTransform(ratio, 0, 0, ratio, 0, 0)

        const renderContext = {
          canvasContext,
          viewport
        }

        pdfPage.render(renderContext)
        /*
        const renderTask = pdfPage.render(renderContext)
        const action = renderTask.promise
          .then(function () {
            if (vm.numPages > num) {
              vm.renderPage(num + 1)
            }
          })
        return action
        */
        // return vm.$commitAction({ action })

        // Wait for rendering to finish
        // renderTask.promise.then(function () {
        //   vm.pageRendering = false
        //   if (vm.pageNumPending !== null) {
        //     // New page rendering is pending
        //     this.renderPage(vm.pageNumPending)
        //     vm.pageNumPending = null
        //   }
        // })
      })
    }
    // queueRenderPage (num) {
    //   if (this.pageRendering) {
    //     this.pageNumPending = num
    //   } else {
    //     this.renderPage(num)
    //   }
    // },
    // onPrevPage () {
    //   if (this.pageNum <= 1) {
    //     return
    //   }
    //   this.pageNum--
    //   this.queueRenderPage(this.pageNum)
    // },
    // onNextPage () {
    //   if (this.pageNum >= this.pdfDoc.numPages) {
    //     return
    //   }
    //   this.pageNum++
    //   this.queueRenderPage(this.pageNum)
    // }
  },

  beforeDestroy () {
    // console.log(this.$refs)
    const { pdfDoc, $refs } = this
    pdfDoc && pdfDoc.cleanup()
    pdfDoc && pdfDoc.destroy()
    for (const key in $refs) {
      if ($refs.hasOwnProperty(key)) {
        const [canvas] = $refs[key]
        if (!canvas) continue
        const ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        canvas.width = canvas.height = 0
        canvas.style.width = canvas.style.height = '0px'
      }
    }
  }

}
</script>

<style lang="stylus" scoped>
</style>
